// Import components
import React, { useMemo, useState , useEffect } from "react";
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { subscribeToTokenRefresh } from "../../../helpers/Refreshfile";
import axios from "axios";
import {Alert,Modal, Label, ModalHeader, Card, CardBody, Row, Col, UncontrolledTooltip } from 'reactstrap';
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png";
import Select from 'react-select';
const baseUrl = process.env.REACT_APP_BASE_URL;



interface column {
    header: string;
    accessorKey?: string;
    accessorFn?: (row: any) => string;
    enableColumnFilter: boolean;
    enableSorting: boolean;
    cell?: (info: any) => React.ReactNode;
}

const AdminEmployee = () => {
   
    const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
    const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false })
    };
    const [showloader, setshowloader] = useState(true);  // State for tracking submission
    


    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [modal_center, setmodal_center] = useState(false);
    const [modal_standard_delete_employee, setmodal_delete_employee] = useState(false);
    const [employeeData, setEmployeeData] = useState<any[]>([]);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState<string | null>(null);
    const [modal_standard_edit_employee, setmodal_edit_employee] = useState(false);
    const [isAdding, setIsAdding] = useState(false);

    const [selectedDomains, setSelectedDomains] = useState<string[]>([]);
    const [all_domain_data, setalldomaindata] = useState<any[]>([]);
    const [selectedBookkeepingTools, setSelectedBookkeepingTools] = useState<string[]>([]);
    const [selectedTaxTools, setSelectedTaxTools] = useState<string[]>([]);

    // Bookkeeping tools options
    const bookkeepingToolsOptions = [
        { value: 'QuickBooks', label: 'QuickBooks' },
        { value: 'NOVO Bank', label: 'NOVO Bank' },
        { value: 'Excel Sheet', label: 'Excel Sheet' },
        { value: 'Xero', label: 'Xero' },
        { value: 'FreshBooks', label: 'FreshBooks' },
        { value: 'Sage', label: 'Sage' },
        { value: 'Wave', label: 'Wave' },
        { value: 'Zoho Books', label: 'Zoho Books' },
        { value: 'NetSuite', label: 'NetSuite' },
        { value: 'Microsoft Dynamics', label: 'Microsoft Dynamics' },
    ];

    // Tax tools options
    const taxToolsOptions = [
        { value: 'ProConnect (Intuit)', label: 'ProConnect (Intuit)' },
        { value: 'Checkpoint (Thomson Reuters)', label: 'Checkpoint (Thomson Reuters)' },
        { value: 'CCH (Wolters Kluwer)', label: 'CCH (Wolters Kluwer)' },
        { value: 'TurboTax (Intuit)', label: 'TurboTax (Intuit)' },
        { value: 'TaxAct (H&R Block)', label: 'TaxAct (H&R Block)' },
        { value: 'Drake Tax (Drake Software)', label: 'Drake Tax (Drake Software)' },
        { value: 'Lacerte (CCH)', label: 'Lacerte (CCH)' },
        { value: 'ProSeries (CCH)', label: 'ProSeries (CCH)' },
    ];

    // Check if bookkeeping domain is selected
    const isBookkeepingDomainSelected = () => {
        return all_domain_data.some(domain => 
            selectedDomains.includes(domain.id.toString()) && 
            domain.name.toLowerCase().includes('bookkeeping')
        );
    };

    // Check if tax domain is selected
    const isTaxDomainSelected = () => {
        return all_domain_data.some(domain => 
            selectedDomains.includes(domain.id.toString()) && 
            domain.name.toLowerCase().includes('tax')
        );
    };

    console.log('employeeData',employeeData)

    function editEmployee(id?: string) {
        if (id !== undefined) {
            setSelectedEmployeeId(id);
        }
        setmodal_edit_employee(true);
        removeBodyCss();
    }


    function closeeditEmployee() {
        setmodal_edit_employee(!modal_standard_edit_employee);
        setErrors({ firstname: '', lastname: '', email: '', phone: '', selectedDomains: '' });
        removeBodyCss();
    }


    function deleteEmployee(id?: string) {
        if (id !== undefined) {
            setSelectedEmployeeId(id);
        }
        setmodal_delete_employee(!modal_standard_delete_employee);
        removeBodyCss();
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }


    function add_employee() {
        setmodal_center(!modal_center);
        setFormValues({firstname: "",lastname: "",email: "",phone: "",image: null});
        setSelectedImage(null);
        setSelectedDomains([]);
        setSelectedBookkeepingTools([]);
        setSelectedTaxTools([]);
        setErrors({ firstname: '', lastname: '', email: '', phone: '', selectedDomains: '' });
        removeBodyCss();
    }

    const handleToggle = (id: string) => {
        const createexp = async () => {
        try {
            setshowloader(true)
            const response = await axios.post(`/accounts/user_active_change`,{ role: 'emp', eid: id },);
            if (response.status === "DONE") {
                fetch_employeelisting();
                setshowloader(false)
                setAlertMsgg({ ...alertMsgg, open: true, content: "User status updated successfully!", type: "success" });
                setEmployeeData((prev) =>
                    prev.map((row: any) =>
                    row.id === id ? { ...row, user: { ...row.user, is_active: !row.user.is_active } } : row)
                    );
                setTimeout(() => {
                    setAlertMsgg({...alertMsgg, open: false, content: "", type: ""})
                }, 4000);
    
    
            }
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }
        };
        createexp();
    };
    

    //  img upload
    const handleImageChangeo = (event: any) => {
        event.preventDefault();
        let reader = new FileReader();
        let file = event.target.files[0];
        reader.onloadend = () => {
        setSelectedImage(reader.result as string);
        };
        reader.readAsDataURL(file);
    };

    const columns: column[] = useMemo(
        () => [
            {
                header: 'S.No',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => row.index + 1,
            },
            {
                header: 'Employee Info',
                enableColumnFilter: false,
                enableSorting: true,
                accessorFn: (row: any) => {
                    const first_name = row?.user?.first_name || '';
                    const email = row?.user?.email || '';
                    return `${first_name} ${email}`;
                },
                cell: ({ row }) => {
                    const category = row.original.user;
                    const date = new Date(row.original.created_at).toLocaleString('en-US', {
                        day: '2-digit', month: 'short', year: 'numeric',
                        hour: '2-digit', minute: '2-digit'
                    });
    
                    return (
                        <div className="d-flex align-items-center">
                            <img
                                src={category.profile_pic
                                ? category.profile_pic
                                : defaultUserImg
                            }
                                alt="User"
                                width="50"
                                height="50"
                                className="rounded-circle object-fit-cover"
                                style={{ marginRight: '10px' }}
                            />
                            <div>
                                <div className="fw-medium">{category.first_name}</div>
                                <div className="font-size-12">{category.email}</div>
                                <div className="font-size-12">{category.phone}</div>
                            </div>
                        </div>
                    );
                },
            },
            {
                header: 'Domains',
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => {
                    const domains = row.original.domains_names || [];
                    const bookkeepingTools = row.original.bookkeeping_tools || [];
                    const taxTools = row.original.tax_tools || [];
                    
                    if (domains.length === 0) {
                        return <div className="fw-medium text-capitalize">N/A</div>;
                    }
                    
                    return (
                        <div className="fw-medium text-capitalize">
                            {domains.map((domain: string, index: number) => {
                                const isBookkeeping = domain.toLowerCase().includes('bookkeeping');
                                const isTax = domain.toLowerCase().includes('tax');
                                const hasTools = (isBookkeeping && bookkeepingTools.length > 0) || (isTax && taxTools.length > 0);
                                const toolsList = isBookkeeping ? bookkeepingTools : (isTax ? taxTools : []);
                                const tooltipId = `tools-tooltip-${row.original.id}-${index}`;
                                
                                return (
                                    <span key={index}>
                                        {domain}
                                        {hasTools && (
                                            <>
                                                <i 
                                                    id={tooltipId}
                                                    className="bx bx-info-circle ms-1 text-primary" 
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                <UncontrolledTooltip placement="top" target={tooltipId}>
                                                    {toolsList.join(', ')}
                                                </UncontrolledTooltip>
                                            </>
                                        )}
                                        {index < domains.length - 1 && ', '}
                                    </span>
                                );
                            })}
                        </div>
                    );
                },
            },
            {
                header: 'Status',
                accessorFn: (row: any) => (row?.user?.is_active ? "Active" : "Inactive"),
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }: any) => {
                    const isActive = row.original.user?.is_active;
                    const id = row.original.id;
                    return (
                    <div className="d-flex align-items-center gap-2">
                        <div className={`fw-medium font-size-12 ${isActive ? 'text-success' : 'text-danger'}`}>
                            {isActive ? 'Active' : 'Inactive'}
                        </div>
                        <div className="form-check form-switch m-0">
                        <input type="checkbox" color="success"  className="form-check-input" id="customSwitchsizesm" checked={isActive}
                            onChange={() => handleToggle(id)}/>
                        {/* <input className="form-check-input" type="checkbox" role="switch" checked={isActive}
                            onChange={() => handleToggle(id)}/> */}
                    </div>
                    </div>
                    );
                },
            },
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: false,
                cell: ( { row })  => (
                    <div className="d-flex gap-2">
                        <button className="btn btn-dark btn-sm" title="Click to Edit" onClick={() => {editEmployee(row.original.id);}}>
                            <i className="bx bx-pencil me-1"></i>
                            Edit
                        </button>
                        <button className="btn btn-danger btn-sm" title="Click to Delete" onClick={() => {deleteEmployee(row.original.id);}}>
                            <i className="bx bxs-trash-alt me-1"></i>
                            Delete
                        </button>
                    </div>
                ),
            }
        ],
        []
    );

    // const staticData = [
    //     {
    //         id: 1,
    //         category: {
    //             first_name: "John Elia",
    //             email: "john@example.com",
    //             phone: "+1 234 567 8901",
    //             profile_pic: "",
    //             is_active: true
    //         },
    //         cstpack: {
    //             plat_pack: { name: "Premium Plan", price: 99 },
    //             created_at: "2025-01-01T10:00:00Z",
    //             payment_status: "paid"
    //         },
    //         admin_verified: "unverified"
    //     },
    //     {
    //         id: 2,
    //         category: {
    //             first_name: "deepak",
    //             email: "deepak@example.com",
    //             phone: "+1 234 567 8901",
    //             profile_pic: "",
    //             is_active: true
    //         },
    //         cstpack: {
    //             plat_pack: { name: "Premium Plan", price: 99 },
    //             created_at: "2025-01-01T10:00:00Z",
    //             payment_status: "paid"
    //         },
    //         admin_verified: "unverified"
    //     }
    // ];

    
    const [formValues, setFormValues] = useState({
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        image: null,
    });

    
    const validateEmail = (email: string) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    
    const validatePhone = (phone: string) => {
        const phoneRegex = /^\+?[0-9]{1,3}?[0-9]{9}$/; // Allows country code + 10 digits
        return phoneRegex.test(phone);
    };

    
    const [error , setErrors] = useState({firstname : '',lastname : '',email : '',phone 
            : '',selectedDomains : ''})

    const add_employee_data = async () => {
        
        console.log('selectedExpert-----',formValues);
        setIsAdding(true);
        
        const newErrors : any = {};
        if(!formValues.firstname) newErrors.firstname = "First name is required!"
        if(!formValues.lastname) newErrors.lastname = "Last Name is required!"
        if(!formValues.phone) {newErrors.phone = "Phone number is required!"}
        else if(!validatePhone(formValues.phone)) {
            newErrors.phone = "Enter a valid phone number!";
        }
        if(!formValues.email) {newErrors.email = "Email is required!"}
        else if(!validateEmail(formValues.email)) {
            newErrors.email = "Invalid email format!";
        }
        if (!selectedDomains || selectedDomains.length === 0) {
        newErrors.selectedDomains = "Please select at least one domain!";
        }


        if(Object.keys(newErrors).length > 0){
            setErrors(newErrors)
            setIsAdding(false);
            return
        }
    
        const formData = new FormData();
        formData.append("firstname", formValues.firstname);
        formData.append("lastname", formValues.lastname);
        formData.append("email", formValues.email);
        formData.append("phone", formValues.phone);
        selectedDomains.forEach(domainId => {
        formData.append('domains', domainId); 
        });

        // Always add bookkeeping_tools (even if empty array) so backend can clear it if needed
        formData.append('bookkeeping_tools', JSON.stringify(selectedBookkeepingTools));
        // Always add tax_tools (even if empty array) so backend can clear it if needed
        formData.append('tax_tools', JSON.stringify(selectedTaxTools));

        if (selectedEmployeeId) {
            formData.append("employee_id", selectedEmployeeId.toString());
            formData.append("action", "edit_employee");

        }
        
        if (selectedImage) {
            console.log('image in ',selectedImage)
            if (typeof selectedImage=== 'string' && selectedImage.startsWith('data:image')) {
                const response = await fetch(selectedImage);
                const blob = await response.blob();
                const file = new File([blob], 'profile.jpg', { type: blob.type });
                
                formData.append('profile_pic', file);
            } 
            else {
                formData.append('profile_pic', selectedImage);
            }
        }
            
        console.log('get data of add_employee_data',formData)
        
        try {
            setshowloader(true)
            const response = await axios.post(`${baseUrl}/accounts/get_add_employee`,formData,{headers: { 'Content-Type': 'multipart/form-data' }});
            console.log('data__fetch_employeelisting',response)
            if (response.status === 'CREATE_EMPLOYEE') {
                // setEmployeeData(response.employee_list);
                
                fetch_employeelisting();
                setmodal_center(false);
                setAlertMsgg({ open: true, content: "Employee created successfully", type: "success" });
                setSelectedImage(null);
                setFormValues({firstname: "",lastname: "",email: "",phone: "",image: null});
                setSelectedDomains([]);
                setSelectedBookkeepingTools([]);
                setSelectedTaxTools([]);
                
                setTimeout(()=> {
                    setAlertMsgg((prev) => ({ ...prev, open: false, content: "", type: "" }));
                },4000)
                setIsAdding(false);
                // fetch_employeelisting();
                setshowloader(false)
            }
            else{setshowloader(false)}
        } catch (error:any) {
            setIsAdding(false);
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }
    };

  
    const fetch_employeelisting = async () => {
        try {
            setshowloader(true)
            const response = await axios.get(`${baseUrl}/accounts/get_add_employee`,{});
            console.log('data__fetch_employeelisting',response)
            if (response.status === 'GET_EMPLOYEE') {
                setEmployeeData(response.employee_list);
                setshowloader(false)

                const dom_data = response.all_domain.map((item:any) => ({
                    id          : item.id,
                    name        : item.name
                }))
                setalldomaindata(dom_data)
            }
            else { setshowloader(false) }
            
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }
    };

    const edit_delete_employee = async () =>{
        console.log('selectedExpert-----',formValues);
        const newErrors : any = {};
        if(!formValues.firstname) newErrors.firstname = "First name is required!"
        if(!formValues.lastname) newErrors.lastname = "Last name is required!"
        if(!formValues.phone) {newErrors.phone = "Phone number is required!"}
        else if(!validatePhone(formValues.phone)) {
            newErrors.phone = "Enter a valid phone number!";
        }
        if(!formValues.email) {newErrors.email = "Email is required!"}
        else if(!validateEmail(formValues.email)) {
            newErrors.email = "Invalid email format!";
        }
        if (!selectedDomains || selectedDomains.length === 0) {
        newErrors.selectedDomains = "Please select at least one domain!";
        }


        if(Object.keys(newErrors).length > 0){
            setErrors(newErrors)
            setIsAdding(false);
            return
        }

        const formData = new FormData();
        formData.append("firstname", formValues.firstname);
        formData.append("lastname", formValues.lastname);
        formData.append("email", formValues.email);
        formData.append("phone", formValues.phone);

        
        selectedDomains.forEach(domainId => {
        formData.append("domains", domainId); 
    });

        // Always add bookkeeping_tools (even if empty array) so backend can clear it if needed
        formData.append('bookkeeping_tools', JSON.stringify(selectedBookkeepingTools));
        // Always add tax_tools (even if empty array) so backend can clear it if needed
        formData.append('tax_tools', JSON.stringify(selectedTaxTools));

        if (selectedEmployeeId) {
            formData.append("employee_id", selectedEmployeeId.toString());
            formData.append("action", "edit_employee");

        }
        
        if (selectedImage) {
            console.log('image in ',selectedImage)
            if (typeof selectedImage=== 'string' && selectedImage.startsWith('data:image')) {
                const response = await fetch(selectedImage);
                const blob = await response.blob();
                const file = new File([blob], 'profile.jpg', { type: blob.type });
                
                formData.append('profile_pic', file);
            } 
            else {
                formData.append('profile_pic', selectedImage);
            }
        }

        console.log('get data of add_employee_data',formData)

        try {
            setshowloader(true)
            const response = await axios.post(`${baseUrl}/accounts/edit_delete_employee`,formData,{headers: { 'Content-Type': 'multipart/form-data' }});
            console.log('data__fetch_employeelisting',response)
            if (response.status === "EDIT_EMPLOYEE") {
                fetch_employeelisting();
                setAlertMsgg({ open: true, content: "Employee edit successfully", type: "success" });
                setmodal_edit_employee(false);
                setSelectedImage(null);
                setFormValues({firstname: "",lastname: "",email: "",phone: "",image: null});
                setSelectedDomains([]);
                setSelectedBookkeepingTools([]);
                setSelectedTaxTools([]);

                setTimeout(()=> {
                    setAlertMsgg((prev) => ({ ...prev, open: false, content: "", type: "" }));
                },4000)
                // setEmployeeData(response.employee_list);
                // fetch_employeelisting();
                setshowloader(false)
            }
            else{setshowloader(false)}
            
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }

        
    };

    const delete_Employee = async (employee_id:any) =>{
        const formData = new FormData();
        formData.append("action", "delete_employee");
        formData.append("employee_id", employee_id);
        try {
            setshowloader(true)
            const response = await axios.post(`${baseUrl}/accounts/edit_delete_employee`,formData);
            if (response.status === "DELETE_EMPLOYEE") {
                fetch_employeelisting();
                setAlertMsgg({ open: true, content: "Employee delete successfully", type: "success" });
                setmodal_delete_employee(false);
                setSelectedImage(null);
                setFormValues({firstname: "",lastname: "",email: "",phone: "",image: null});

                setTimeout(()=> {
                    setAlertMsgg((prev) => ({ ...prev, open: false, content: "", type: "" }));
                },4000)
                setshowloader(false)
            }
            else{setshowloader(false)}
            
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }

    }

    useEffect(() => {
        fetch_employeelisting();
        subscribeToTokenRefresh(() => {
            console.log("🔁 Token refreshed. Re-fetching experts...");
            fetch_employeelisting();
        });
    }, []);
    useEffect(() => {console.log('Updated employeeData:', employeeData);}, [employeeData]);
    useEffect(() => {
    if (selectedEmployeeId !== null && employeeData.length > 0) {
        const selectedEmployee = employeeData.find(
        (employee) => employee.id === selectedEmployeeId
        );

        // console.log("💥 Employee loaded:", selectedEmployee);

        if (selectedEmployee) {
        const user = selectedEmployee.user;
        setFormValues({
            firstname: user.first_name || '',
            lastname: user.last_name || '',
            email: user.email || '',
            phone: user.phone || '',
            image: user.profile_pic || null,
        });
        setSelectedImage(user.profile_pic || null);
        const domainIds = selectedEmployee.domains.map((id: number) => id.toString());
            setSelectedDomains(domainIds);
        // Load bookkeeping_tools if available
        if (selectedEmployee.bookkeeping_tools && Array.isArray(selectedEmployee.bookkeeping_tools)) {
            setSelectedBookkeepingTools(selectedEmployee.bookkeeping_tools);
        } else {
            setSelectedBookkeepingTools([]);
        }
        // Load tax_tools if available
        if (selectedEmployee.tax_tools && Array.isArray(selectedEmployee.tax_tools)) {
            setSelectedTaxTools(selectedEmployee.tax_tools);
        } else {
            setSelectedTaxTools([]);
        }
        }
    }
    }, [selectedEmployeeId, employeeData]);

    document.title = "Employees | BizServe";

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title="Admin" breadcrumbItem="Employees" />
                {alertMsgg.open && (
                <Alert 
                    color={alertMsgg.type === "success" ? "success" : "danger"} 
                    toggle={handleAlertMsggClose}
                    fade={true}
                    style={{ fontWeight: "bold" }}
                > {alertMsgg.content}
                </Alert>
                )}

                {/* <Breadcrumbs title="Domains " breadcrumbItem="Domains" /> */}

                <div className="loaderContainer" hidden={!showloader}>
                    <div className="spinner">
                        <div></div>   
                        <div></div>    
                        <div></div>    
                        <div></div>    
                        <div></div>    
                        <div></div>    
                        <div></div>    
                        <div></div>    
                        <div></div>    
                        <div></div>    
                    </div>
                </div>
                <Row>
                    <Col md={12} className="d-flex justify-content-end align-items-center mb-3">
                        <button
                        type="button"
                        className="btn btn-primary "
                        onClick={() => {
                            add_employee();
                        }}
                        >
                        Add Employee
                        </button>
                    </Col>
                    <Col md={12}>
                        <Card className="rounded-4 border">
                            <CardBody>
                                <TableContainer
                                    columns={columns}
                                    data={employeeData || []}
                                    isGlobalFilter={true}
                                    isPagination={true}
                                    SearchPlaceholder="Search By Name..."
                                    pagination="pagination"
                                    paginationWrapper='dataTables_paginate paging_simple_numbers'
                                    tableClass="table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Modal
                    isOpen={modal_center}
                    toggle={() => {
                    add_employee();
                    }}
                    size="lg"
                    backdrop={'static'}
                    centered
                >
                    <ModalHeader toggle={() => {add_employee()}}>
                        <div className="modal-title mt-0 font-size-16 text-dark">Add Employee</div>
                    </ModalHeader>
                    <div className="modal-body">
                        <Row>
                        <Col lg={12}>
                            <div className="mb-3 border-bottom pb-3 text-center">
                            <div className="mb-3">
                                <div className="text-center">
                                <div className="position-relative bottom-0 end-0">
                                    <Label htmlFor="project-image-input" className="mb-0 position-relative" id="projectImageInput">
                                    <div className="avatar-xs imageChangeFloat">
                                        <div className="avatar-title bg-light border rounded-circle text-muted cursor-pointer shadow font-size-16">
                                        <i className="bx bxs-image-alt"></i>
                                        </div>
                                    </div>
                                    <div className="avatar-lg">
                                        <div className="avatar-title bg-light rounded-circle">
                                        <img src={selectedImage || defaultUserImg} id="projectlogo-img" alt="" className="avatar-md  rounded-circle object-fit-cover" />
                                        </div>
                                    </div>
                                    </Label>
                                    <input className="form-control d-none" id="project-image-input" type="file" accept="image/png, image/gif, image/jpeg" onChange={handleImageChangeo} />
                                </div>
                                </div>
                                </div>
                            <Label className="form-label ">Employee Image</Label>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="mb-3">
                            <label className="form-label">First Name<span className="text-danger px-1">*</span></label>
                            <input
                                className={`form-control ${error.firstname ? 'is-invalid' : ''}`}
                                type="text"
                                placeholder="First Name"
                                value={formValues.firstname}
                                onChange={(e) => {setFormValues({ ...formValues, firstname: e.target.value });
                                setErrors((prev) => ({ ...prev,firstname: ''}));
                            }}   
                            />
                            {error.firstname && <div className="invalid-feedback">{error.firstname}</div>}
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="mb-3">
                            <label className="form-label">Last Name<span className="text-danger px-1">*</span></label>
                            <input
                                className={`form-control ${error.lastname ? 'is-invalid' : ''}`}
                                type="text"
                                placeholder="Last Name"
                                value={formValues.lastname}
                                onChange={(e) => {setFormValues({ ...formValues, lastname: e.target.value });
                                setErrors((prev) => ({ ...prev,lastname: ''}));
                            }}
                            />
                            {error.lastname && <div className="invalid-feedback">{error.lastname}</div>}
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="mb-3">
                            <label className="form-label">Email<span className="text-danger px-1">*</span></label>
                            <input
                                className={`form-control ${error.email ? 'is-invalid' : ''}`}
                                type="email"
                                placeholder="Enter Email"
                                value={formValues.email}
                                onChange={(e) => {setFormValues({ ...formValues, email: e.target.value });
                                setErrors((prev) => ({ ...prev,email: ''}));
                            }}
                            />
                            {error.email && <div className="invalid-feedback">{error.email}</div>}
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="mb-3" >
                            <label className="form-label">Phone<span className="text-danger px-1">*</span></label>
                            <input
                                className={`form-control ${error.phone ? 'is-invalid' : ''}`}
                                type="text"
                                placeholder="Enter Phone number"
                                value={formValues.phone}
                                onChange={(e) => {setFormValues({ ...formValues, phone: e.target.value });
                            setErrors((prev) => ({ ...prev,email: ''}));
                        }}
                            />
                            {error.phone && <div className="invalid-feedback">{error.phone}</div>}
                            </div>
                        </Col>
                        <Col lg={12}>
                            <div className="mb-3">
                                <label className="form-label">Select Domains<span className="text-danger px-1">*</span></label>
                                <Select isMulti name="domains" options={all_domain_data.map(domain => ({
                                    value: domain.id.toString(),label: domain.name}))}
                                value={selectedDomains.map(id => {const domain = all_domain_data.find(d => d.id.toString() === id);
                                    return domain ? { value: domain.id.toString(), label: domain.name } : null;
                                }).filter(Boolean)}
                                onChange={(selectedOptions) => {const ids = Array.isArray(selectedOptions)
                                    ? selectedOptions.filter((option): option is { value: string } => option !== null && typeof option === 'object' && 'value' in option).map(option => option.value): [];
                                setSelectedDomains(ids);
                                setErrors((prev) => ({ ...prev,selectedDomains: ''}));
                                }}
                                // className="select2-selection"
                                className={`select2-selection ${error.selectedDomains ? 'is-invalid is-invalid-custom' : ''}`}
                                placeholder="Select domains..."
                                />
                                {error.selectedDomains && <div className="invalid-feedback">{error.selectedDomains}</div>}
                            </div>
                        </Col>

                        {/* Bookkeeping Tools - Show only if bookkeeping domain is selected */}
                        {isBookkeepingDomainSelected() && (
                        <Col lg={12}>
                            <div className="mb-3">
                                <label className="form-label">Bookkeeping Tools</label>
                                <Select
                                    isMulti
                                    name="bookkeeping_tools"
                                    options={bookkeepingToolsOptions}
                                    value={selectedBookkeepingTools.map(tool => ({
                                        value: tool,
                                        label: tool
                                    }))}
                                    onChange={(selectedOptions) => {
                                        const tools = Array.isArray(selectedOptions)
                                            ? selectedOptions.map(option => option.value)
                                            : [];
                                        setSelectedBookkeepingTools(tools);
                                    }}
                                    className="select2-selection"
                                    placeholder="Select bookkeeping tools..."
                                />
                            </div>
                        </Col>
                        )}

                        {/* Tax Tools - Show only if tax domain is selected */}
                        {isTaxDomainSelected() && (
                        <Col lg={12}>
                            <div className="mb-3">
                                <label className="form-label">Tax Tools</label>
                                <Select
                                    isMulti
                                    name="tax_tools"
                                    options={taxToolsOptions}
                                    value={selectedTaxTools.map(tool => ({
                                        value: tool,
                                        label: tool
                                    }))}
                                    onChange={(selectedOptions) => {
                                        const tools = Array.isArray(selectedOptions)
                                            ? selectedOptions.map(option => option.value)
                                            : [];
                                        setSelectedTaxTools(tools);
                                    }}
                                    className="select2-selection"
                                    placeholder="Select tax tools..."
                                />
                            </div>
                        </Col>
                        )}

                        <Col lg={12}>
                            <div className="d-flex justify-content-end">
                                <button
                                className="btn btn-primary mb-3"
                                onClick={add_employee_data}
                                disabled={isAdding} // disable during request
                                >
                                {isAdding ? "Adding..." : "Add Employee"}
                                </button>
                            </div>
                        </Col>

                        </Row>
                    </div>
                </Modal>

                <Modal
                    isOpen={modal_standard_edit_employee}
                    toggle={() => {
                    editEmployee();
                    }}
                    size="lg"
                    backdrop={'static'}
                    centered
                >
                    <ModalHeader toggle={() => {
                    closeeditEmployee();
                    }}>
                    <div className="modal-title mt-0 font-size-16 text-dark">Edit Employee</div>
                    </ModalHeader>
                    <div className="modal-body">
                    <Row>
                    <Col lg={12}>
                        <div className="mb-3 border-bottom pb-3 text-center">
                        

                        <div className="mb-3">

                            <div className="text-center">
                            <div className="position-relative bottom-0 end-0">
                                <Label htmlFor="project-image-input" className="mb-0 position-relative" id="projectImageInput">
                                <div className="avatar-xs imageChangeFloat">
                                    <div className="avatar-title bg-light border rounded-circle text-muted cursor-pointer shadow font-size-16">
                                    <i className="bx bxs-image-alt"></i>
                                    </div>
                                </div>
                                <div className="avatar-lg">
                                    <div className="avatar-title bg-light rounded-circle">
                                    <img src={selectedImage || defaultUserImg} id="projectlogo-img" alt="" className="avatar-md  rounded-circle object-fit-cover" />
                                    </div>
                                </div>
                                </Label>
                                <input className="form-control d-none" id="project-image-input" type="file" accept="image/png, image/gif, image/jpeg" onChange={handleImageChangeo} />
                            </div>
                            </div>
                            </div>
                        <Label className="form-label ">Employee Image</Label>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3">
                        <label className="form-label">First Name<span className="text-danger px-1">*</span></label>
                        <input
                            className={`form-control ${error.firstname ? 'is-invalid' : ''}`}
                            type="text"
                            placeholder="First Name"
                            value={formValues.firstname}
                            onChange={(e) => {setFormValues({ ...formValues, firstname: e.target.value });
                            setErrors((prev) => ({ ...prev,firstname : ''}));
                        }}
                        />
                        {error.firstname && <div className="invalid-feedback">{error.firstname}</div>}
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3">
                        <label className="form-label">Last Name<span className="text-danger px-1">*</span></label>
                        <input
                            className={`form-control ${error.lastname ? 'is-invalid' : ''}`}
                            type="text"
                            placeholder="Last Name"
                            value={formValues.lastname}
                            onChange={(e) => {setFormValues({ ...formValues, lastname: e.target.value });
                            setErrors((prev) => ({ ...prev,lastname: ''}));
                        }}
                        />
                        {error.lastname && <div className="invalid-feedback">{error.lastname}</div>}
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3">
                        <label className="form-label">Email<span className="text-danger px-1">*</span></label>
                        <input
                            className={`form-control ${error.email ? 'is-invalid' : ''}`}
                            type="email"
                            placeholder="Enter Email"
                            value={formValues.email}
                            onChange={(e) => {setFormValues({ ...formValues, email: e.target.value });
                            setErrors((prev) => ({ ...prev,email: ''}));
                        }}
                        />
                        {error.email && <div className="invalid-feedback">{error.email}</div>}
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3" >
                        <label className="form-label">Phone<span className="text-danger px-1">*</span></label>
                        <input
                            className={`form-control ${error.phone ? 'is-invalid' : ''}`}
                            type="text"
                            placeholder="Enter Phone number"
                            value={formValues.phone}
                            onChange={(e) => {setFormValues({ ...formValues, phone: e.target.value });
                            setErrors((prev) => ({ ...prev,phone: ''}));
                        }}
                        />
                        {error.phone && <div className="invalid-feedback">{error.phone}</div>}
                        </div>
                    </Col>
                    <Col lg={12}>
                            <div className="mb-3">
                                <label className="form-label">Domains<span className="text-danger px-1">*</span></label>
                                <Select isMulti name="domains" options={all_domain_data.map(domain => ({
                                    value: domain.id.toString(),label: domain.name}))}
                                value={selectedDomains.map(id => {const domain = all_domain_data.find(d => d.id.toString() === id);
                                    return domain ? { value: domain.id.toString(), label: domain.name } : null;
                                }).filter(Boolean)}
                                onChange={(selectedOptions) => {const ids = Array.isArray(selectedOptions)
                                    ? selectedOptions.filter((option): option is { value: string } => option !== null && typeof option === 'object' && 'value' in option).map(option => option.value): [];
                                setSelectedDomains(ids);
                                setErrors((prev) =>({ ...prev,selectedDomains:''}));
                                }}
                                className={`select2-selection ${error.selectedDomains ? 'is-invalid is-invalid-custom' : ''}`}
                                placeholder="Select domains..."
                                />
                                {error.selectedDomains && <div className="invalid-feedback">{error.selectedDomains}</div>}
                            </div>
                        </Col>

                        {/* Bookkeeping Tools - Show only if bookkeeping domain is selected */}
                        {isBookkeepingDomainSelected() && (
                        <Col lg={12}>
                            <div className="mb-3">
                                <label className="form-label">Bookkeeping Tools</label>
                                <Select
                                    isMulti
                                    name="bookkeeping_tools"
                                    options={bookkeepingToolsOptions}
                                    value={selectedBookkeepingTools.map(tool => ({
                                        value: tool,
                                        label: tool
                                    }))}
                                    onChange={(selectedOptions) => {
                                        const tools = Array.isArray(selectedOptions)
                                            ? selectedOptions.map(option => option.value)
                                            : [];
                                        setSelectedBookkeepingTools(tools);
                                    }}
                                    className="select2-selection"
                                    placeholder="Select bookkeeping tools..."
                                />
                            </div>
                        </Col>
                        )}

                        {/* Tax Tools - Show only if tax domain is selected */}
                        {isTaxDomainSelected() && (
                        <Col lg={12}>
                            <div className="mb-3">
                                <label className="form-label">Tax Tools</label>
                                <Select
                                    isMulti
                                    name="tax_tools"
                                    options={taxToolsOptions}
                                    value={selectedTaxTools.map(tool => ({
                                        value: tool,
                                        label: tool
                                    }))}
                                    onChange={(selectedOptions) => {
                                        const tools = Array.isArray(selectedOptions)
                                            ? selectedOptions.map(option => option.value)
                                            : [];
                                        setSelectedTaxTools(tools);
                                    }}
                                    className="select2-selection"
                                    placeholder="Select tax tools..."
                                />
                            </div>
                        </Col>
                        )}

                    <Col lg={12}>
                        <div className="d-flex justify-content-end">
                        {/* <button className="btn btn-primary mb-3">Edit Employee</button> */}
                        <button className="btn btn-primary mb-3" onClick={()=> edit_delete_employee()}>Edit Employee</button>
                        </div>
                    </Col>
                    </Row>
                    </div>
                </Modal>    
                
                <Modal
                    isOpen={modal_standard_delete_employee}
                    toggle={() => {deleteEmployee()}}
                centered
                className="rounded-4"
                >
                <ModalHeader className="py-3 px-4" toggle={() => {deleteEmployee()}}>
                    <div className="modal-title mt-0 font-size-16 text-dark">
                    Delete Employee
                    </div>
                </ModalHeader>

                <div className="modal-body">
                    <p>Are you sure you want to delete this employee?</p>
                </div>

                <div className="modal-footer">
                    <button 
                    type="button" 
                    className="btn btn-sm btn-soft-dark" 
                    onClick={() => {deleteEmployee()}}
                    >
                    Cancel
                    </button>
                    <button 
                    type="button" 
                    className="btn btn-sm btn-danger" 
                    onClick={() => {
                        console.log("Deleting ID:", selectedEmployeeId);
                        delete_Employee(selectedEmployeeId)
                    }}
                    >
                    Delete
                    </button>
                </div>
                </Modal>
            </div>
        </div>
    );
};

export default AdminEmployee;
